import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { tokenStorage } from "../bundles/common/tokenStorage";
import remoteSchema from "./remote.schema.graphql";
import localSchema from "./local.schema.graphql";
import { localResolvers } from "./local.resolvers";
//import { navigate } from "@reach/router";
import config from "../config";

import { split } from "apollo-link";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";

const cache = new InMemoryCache();

let refreshPromise: Promise<string> = null; // keep track of the current refresh request, don't call it if it's in progress

const fetchWithToken = (
  uri: string,
  options: RequestInit
): Promise<Response> => {
  let originalResponse: Response = null;

  return fetch(uri, options)
    .then((response) => {
      originalResponse = response;
      return response.clone().json();
    })
    .then((json) => {
      if (
        json &&
        json.errors &&
        json.errors[0] &&
        json.errors[0].extensions &&
        json.errors[0].extensions.code === "UNAUTHENTICATED"
      ) {
        if (!refreshPromise) {
          const params = {
            operationName: "RefreshToken",
            query: `
									mutation RefreshToken {
										refreshToken
									}
								`,
          };

          // Execute the re-authorization request and set the promise returned to this.refreshPromise
          refreshPromise = fetch(uri, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(params),
          })
            .then((refreshResponse) => refreshResponse.json())
            .then((refreshResponseJson) => {
              if (
                refreshResponseJson.data &&
                refreshResponseJson.data.refreshToken
              ) {
                const newToken = refreshResponseJson.data
                  .refreshToken as string;
                tokenStorage.accessToken = newToken;
                return newToken;
              } else {
                tokenStorage.clearToken();
                //navigate("/").then();
              }
            })
            .catch((error) => {
              return Promise.reject(error);
            });
        }

        return refreshPromise.then((newAccessToken) => {
          refreshPromise = null;

          // Set the authorization header on the original options parameter to the new access token we got
          (options.headers as any)[
            "Authorization"
          ] = `Bearer ${newAccessToken}`;

          // Return the promise from the new fetch (which should now have used an active access token)
          // If the initialRequest had errors, this fetch that is returned below is the final result.
          return fetch(uri, options);
        });
      }

      //If there were no errors in the initialRequest, return original response.
      return originalResponse;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

const wsLink = new WebSocketLink({
  uri: config.apiUrlWS,
  options: {
    reconnect: true,
    // timeout: 10000,
    // connectionParams: {
    // 	authToken: tokenStorage.accessToken,
    // },
  },
});

const uploadLink = createUploadLink({
  uri: config.apiUrl,
  credentials: "include",
  fetch: fetchWithToken,
});

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  uploadLink
);

export const apolloClient = new ApolloClient({
  cache,
  typeDefs: [remoteSchema, localSchema],
  resolvers: localResolvers,
  link: link,
});
